var _defs, _rect, _line, _line2, _path, _rect2, _path2, _line3, _line4, _line5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloudIconGameTypeJoyApassageLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .joyapassage-shape {\n        stroke-width: 2px;\n      }\n\n      .joyapassage-shape, .joyapassage-text {\n        fill: none;\n        stroke: currentColor;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .joyapassage-text {\n        stroke-width: 1.5px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "joyapassage-shape",
    x: 3.1,
    y: 5.2,
    width: 43.7,
    height: 39.6,
    rx: 6.6,
    ry: 6.6
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "joyapassage-shape",
    x1: 30.5,
    y1: 38,
    x2: 10.4,
    y2: 38
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "joyapassage-shape",
    x1: 39.6,
    y1: 31.2,
    x2: 10.4,
    y2: 31.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "joyapassage-shape",
    d: "M9.2,10.9h9.8v14h-9.8c-1,0-1.8-.8-1.8-1.8v-10.3c0-1.2.9-1.9,1.8-1.9h0Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "joyapassage-shape",
    x: 19,
    y: 10.9,
    width: 11.6,
    height: 14
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "joyapassage-shape",
    d: "M30.6,10.9h9.8c1,0,1.8.8,1.8,1.8v10.3c0,1-.8,1.8-1.8,1.9h-9.8s0-14,0-14Z"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "joyapassage-text",
    x1: 13,
    y1: 14.9,
    x2: 10.3,
    y2: 20.8
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "joyapassage-text",
    x1: 13,
    y1: 14.9,
    x2: 15.8,
    y2: 20.8
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "joyapassage-text",
    x1: 11.1,
    y1: 19.3,
    x2: 15,
    y2: 19.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudIconGameTypeJoyApassageLine);
export default __webpack_public_path__ + "static/media/cloud_icon_game_type_JOYApassage_line.094b7e316b6b3c7f6c01aa92da7b2d85.svg";
export { ForwardRef as ReactComponent };